import { useEffect, useState } from 'react';
import './App.css';
import WordGuess from './WordGuess';
import GuessDisplay from './GuessDisplay';
import RemainingDisplay from './RemainingDisplay';
import WordsList from './words.txt'
import Keyboard from './Keyboard';
import StrokeCounts from './StrokeCounts';
import LetterComparator from './LetterComparator';

function App() {

  const [words, setWords] = useState([]);
  
  const [previousGuesses, setPreviousGuesses] = useState([]);
  const [remainingGuesses, setRemainingGuesses] = useState(5);
  const [currentIndex, setCurrentIndex] = useState(0);

  const [targetWord, setTargetWord] = useState('');
  const [foundAnswer, setFoundAnswer] = useState(false);

  const [potentialLetters, setPotentialLetters] = useState([]);


  useEffect( () => {
      chooseWord();
      resetPotentialLetters();
  }, []);

  function chooseWord(){
    fetch(WordsList)
      .then((r) => r.text())
      .then(text => {
        let words = text.split('\n')
        setWords(words);    
        const target = words[Math.floor((Math.random()*words.length))] 
        setTargetWord(target);
        console.log(target.toUpperCase());
      });
  }

  function resetPotentialLetters(){
    let strokes = StrokeCounts();
    
    let potentialLettersArray = [];
    Array.from({length: 5}, (_, i) => {
      let letterArray = []
      for (const [letter, _] of Object.entries(strokes))
      {
        letterArray.push(letter);
      }
    
      potentialLettersArray.push(letterArray);
    })
    setPotentialLetters(potentialLettersArray);
    console.log(potentialLettersArray)
  }

  const onIndexChanged = (index) => {
    setCurrentIndex(index);
  }

  const wordValidator = (word) => {
      return words.indexOf(word.toLowerCase()) > -1
    }

  const wordSubmission = (word) => {
    let lowerCase = word.toLowerCase();

    var currentGuesses = previousGuesses.slice();
    currentGuesses.push(lowerCase);
    setPreviousGuesses(currentGuesses);

    if (lowerCase === targetWord){
      setFoundAnswer(true);
      resetPotentialLetters();
      return;
    }
    const guessesLeft = remainingGuesses - 1
    if(guessesLeft === -1){
      alert(`the word was ${targetWord}`);
    }
    setRemainingGuesses(guessesLeft);
    
    let results = LetterComparator(lowerCase, targetWord);

    var potentials = potentialLetters;
    for (const [i, options] of Object.entries(results))
    {      
      if (options.remainingOptions.length === 0){
        continue;
      }
      for (let j = 0; j < potentialLetters[i].length; j++){
        let letter = potentialLetters[i][j];     
        if(options.remainingOptions.indexOf(letter) === -1){
           potentials[i].splice(j, 1);
          j--;
        }   
      }
    }
    setPotentialLetters(potentials);
  }

  return (
    <div className="App">
      <h1>Storkdle</h1>
      {
        previousGuesses.map((guess, index) => (
            <GuessDisplay guess={guess} targetWord={targetWord} index={index} key={`GuessDisplay-${index}`}/>
        ))
      }
      { !foundAnswer && previousGuesses.length < 6 ?
        <WordGuess wordValidator={wordValidator} wordSubmission={wordSubmission} onIndexChanged={onIndexChanged} /> :<></> 
      }
      {
        Array.from({ length: remainingGuesses }, (_, i) => (  
            <RemainingDisplay index={i} key={`RemainingDisplay-${i}`}/>
        ))
      }
      <Keyboard highlights={potentialLetters[currentIndex]}/>
    </div>
  );
}

export default App;